if (!("structuredClone" in window)) {
	(window as Window).structuredClone = function structuredClone<T = any>(input: T): T {
		if (input === undefined) {
			return undefined;
		}

		return JSON.parse(JSON.stringify(input));
	};
}
